import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const LoraProviderFilterField = props => (
  <SelectField
    fullWidth
    value={props.filter ? props.filter.value : ''}
    onChange={(event, index, value) => props.onFilterChange(value)}
  >
    <MenuItem value="" primaryText="All" />
    <MenuItem value="SLS" primaryText="SLS" />    
    <MenuItem value="LORIOT" primaryText="Loriot" />
    <MenuItem value="FIREFLY" primaryText="Firefly" />
    <MenuItem value="SWISSCOM" primaryText="Swisscom" />
    <MenuItem value="TTN" primaryText="TTN" />
  </SelectField>
);

export default LoraProviderFilterField;



// WEBPACK FOOTER //
// ./src/components/filters/LoraProviderFilterField.js